/**
 * @file   房间一 木材介绍
 * @create macaiqi 2025/06/20
 * @update
 */
import { useEffect, useState } from "react";
import { queryArchivesById, queryFileList } from "../../service";
import { htmltoStr } from "../../utils";
import cls from 'classnames'

export default function ImgShade({ linkid, setShow, floorAt }) {
    const [data, setData] = useState()
    const [filedata, setFileData] = useState([])

    useEffect(() => {
        if (linkid) {
            queryArchivesById(linkid).then(res => {
                setData(res)
                if (floorAt === 0) {
                    queryFileList({
                        pagination: {
                            size: 0,
                            page: 0
                        },
                        params: {
                            groupId: res?.groupId,
                            code:
                                "CMS_ARCHIVES_IMG"
                        }
                    }).then(res1 => {
                        console.log(res1?.records)
                        setFileData(res1?.records || [])
                    })
                }

            })
        }

    }, [floorAt, linkid])
    return (
        <div className="shade animate__animated animate__fadeIn animate__fast">
            <i
                className="close1"
                onClick={() => {
                    setShow('zqf');
                }}></i>
            <div className={cls("imgcontent", { 'imgcontent4': floorAt === 2 })}>
                <div className="title">
                    {data?.title?.split("").map((item, index) => {
                        return (
                            <div key={index} className="txt">
                                <span>{item}</span>
                            </div>
                        )
                    })}
                </div>
                <div className="des">
                    {htmltoStr(data?.content)}
                </div>
                {floorAt === 0 && <div className="imglist">
                    {filedata?.map((item, index) => {
                        return (
                            <div className="item">
                                <img src={item.filePath} alt="" srcset="" key={index} />
                                <p>{item.title}</p>
                            </div>
                        )
                    })}
                </div>}
                {floorAt === 2 &&
                    <img src={window.ENV_IMG_PREURL + data?.imgSrc} alt="" srcset="" />
                }
            </div>

        </div>
    );
}
